{
  "version": 1,
  "asset_id": "8bf0c55b-7f60-4e53-b0d1-d8f1da63bdb6",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/8bf0c55b-7f60-4e53-b0d1-d8f1da63bdb6/engine-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/8bf0c55b-7f60-4e53-b0d1-d8f1da63bdb6/engine-card.webp",
  "original_filename": "engine-card.webp",
  "size": 44402,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:14Z"
}
